<template>
  <a-modal :visible="showDialog" :mask="true" :maskClosable="false" :title="title" @ok="handleOk"
    @cancel="handleCancel()">
    <a-form layout="vertical" >
      <a-alert type="info" closable>
        <span slot="description">
          <span style="color :#52c41a">
            <a-icon slot="existent" type="check-circle" /> 已有权限
          </span>
          <a-icon slot="non-existent" type="close-circle" /> 无权限
        </span>
      </a-alert>
      <a-form-item label="" style="max-height:50vh;overflow-y:scroll;margin-top: 10px;">
        <a-tree
          v-model="userInfo.auth"
          checkable 
          show-icon
          defaultExpandAll 
          :defaultSelectedKeys="userInfo.auth2"
          :auto-expand-parent="autoExpandParent" 
          :tree-data="menuList" 
          :checkedKeys="businessSelectedRowKeys"
          @check="onCheck">
          <a-icon slot="existent" type="check-circle" theme="twoTone" two-tone-color="#52c41a" />
          <a-icon slot="non-existent" type="close-circle" />
        </a-tree>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { UserSave } from "../../api/v1/user_api";

export default {
  name: "UserAuthDialog",
  props: ['userInfo', 'showDialog', 'menuList', 'type','title'],
  data() {
    return {
      autoExpandParent: true,
      businessSelectedRowKeys: [],
      allSelectedNodes: []
    }
  },

  methods: {
    handleOk() {
      if (this.userInfo.auth.length != 0 && this.allSelectedNodes.length == 0) {
        this.$message.success('保存成功')
        this.$emit('close-dialog')
        return false
      }

      if (this.allSelectedNodes == this.userInfo.auth2) {
        this.$message.success('保存成功')
        this.$emit('close-dialog')
        return false
      }
      let auth
      // if (this.userInfo.auth.checked) {
      //     auth = this.userInfo.auth.checked
      // } else {
      //     auth = this.userInfo.auth
      // }
      auth = this.allSelectedNodes
      let data
      if (this.type == 'oldgb') {
        data = {
          "id": this.userInfo.id,
          "oldgb_auth": auth
        }
      } else {
        data = {
          "id": this.userInfo.id,
          "auth": auth
        }
      }
      UserSave(data).then(resp => {
        if (resp.code === 200) {
          this.$message.success(resp.msg)
          this.$emit('close-dialog')
        } else {
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel() {
      this.$emit('close-dialog')
    },
    onCheck(selectedKeys, e) {
      // 已勾选子节点以及半勾选状态的父节点
      this.allSelectedNodes = selectedKeys.concat(e.halfCheckedKeys);
      this.userInfo.auth = selectedKeys;
    },

  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/V1/UserAuthDialog.vue